import { createFileRoute } from '@tanstack/react-router'
import { orgDiarySearchSchema } from '@/features/diary/grade-org-diary/model/orgDiarySearch'
import { OrgDiaryPage } from '@/pages/internships/ui/OrgDiaryPage'
export const Route = createFileRoute('/grading')({
  validateSearch: orgDiarySearchSchema,
  component: OrgDiaryPage,
})
